import Common from './Common';
import Project from './Project';

const commonRequestObj = new Common();
const commonRequest = commonRequestObj.axiosInstance;
export default commonRequest;

const projectRequestObj = new Project();
export const projectRequest = projectRequestObj.axiosInstance;
